import * as React from 'react';
import { actionCreators as userActions } from '@src/app/user/actions';
import { actionCreators as weakActionCreators } from '@src/app/login/weak/actions';
import { connect } from 'react-redux';
import { RootState, Dispatch } from '@src/app/_redux';
import { bindActionCreators } from 'redux';
import { WsgRequest, WsgRequestPayload } from '@src/app/_global/domain/WsgRequest';
import { AccountLookupTypes } from '@src/app/_global/domain/AccountLookupTypes';
import { LoadingView } from '@src/app/_global/components/Loading';
import { Redirect } from 'react-router';
import { getProdIdsForGlobalCodeFromAdminConfig } from '@src/app/accounts/selectors';
export interface DirectViewProps {
  accountNumber: string;
  orderNumber: string;
  postalCode: string;
  path: string;
  directViewLoginAction: any;
  loginAccountNumberAction: any;
  initiateDirectViewLoginAction: any;
  getIamKeys: any;
  credentials: any;
  clientConfig: any;
  adminConfig: any;
  customers: any;
  productExcludes: any;
  emailAddress: string;
  entityId: string;
}
const getRedirectUrl = (path: string, accountNumber: string, orderNumber: string, entityId: string, emailAddress: string, postalCode: string) => {
  switch (path) {
    case 'payments':
      return orderNumber ?  `/accounts/payments/${orderNumber}` : `/accounts/payments`;
    case 'email-auth':
      return `/accounts/email-auth`;
    case 'redeemgift':
      return `/accounts/redeemgift/${entityId}/${emailAddress}`;
    case 'renewals':
      return `/accounts/ordersrenewals/${orderNumber}/${accountNumber}`;
    default:
      return '/error';
  }
};
export class DirectViewForm extends React.Component<DirectViewProps> {
  constructor(props: any) {
    super(props);
  }

  async componentDidMount() {
      // set the directView indicator into userState
      this.props.directViewLoginAction({payload: true});
      this.props.loginAccountNumberAction({payload: this.props.accountNumber});

      let defaultMagClientProperty;
      let tableName = 'ClientProperties';
      if (this.props.adminConfig[this.props.clientConfig.magCode]) {
        defaultMagClientProperty = this.props.adminConfig[this.props.clientConfig.magCode][tableName];
      }

      // now lookup the user
      const payload: WsgRequestPayload = {
        acctNbr: this.props.accountNumber, 
        postalCode: this.props.postalCode,
        emailOptIn: 'N',
        email: '',
        productExcludes: this.props.productExcludes,
      };
      var wsgPayload: WsgRequest = {
        magCode: this.props.clientConfig.magCode,
        globalCode: this.props.clientConfig.globalCode,
        filterType: AccountLookupTypes.accountNumberPostalCode,
        directView: true,
        payload,
        systemCode: defaultMagClientProperty.ProductType,
      };
      this.props.getIamKeys(wsgPayload);
  }
  
  render() {
    const { credentials, path, accountNumber, orderNumber, customers, entityId, emailAddress, postalCode} = this.props;
    return (
      <div className="direct-view">
        { !credentials && !customers ? (
            <LoadingView loadingText="Loading..."/>
          ) : (          
            <Redirect to={getRedirectUrl(path, accountNumber, orderNumber, entityId, emailAddress, postalCode)}/>
        )}
      </div>);
  }
}

const mapStateToProps = (state: RootState, props) => {
  return {
    path: props.match.params.path,
    accountNumber: props.match.params.accountNumber,
    orderNumber: props.match.params.orderNumber,
    postalCode: props.match.params.postalCode,
    entityId: props.match.params.orderNumber,  // repurposing this URL position for CORE Gift Redemption
    emailAddress: props.match.params.emailAddress,
    credentials: state.auth.omsAuth.credentials,
    clientConfig: state.clientConfig.clientConfig,
    adminConfig: state.adminConfig.adminConfig,
    customers: state.account.customerData.customers,
    productExcludes: getProdIdsForGlobalCodeFromAdminConfig(state),
  };
};
const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      directViewLoginAction: userActions.directViewLogin,
      getIamKeys: weakActionCreators.unauthGetIamKeys,
      loginAccountNumberAction: userActions.loginAccountNumber,
    },
    dispatch,
  );

export const DirectView = connect(mapStateToProps, mapDispatchToProps)(DirectViewForm);
